import React, { useCallback, useState } from 'react';
import { forceFocus } from 'pages/Activities/utils';
import Grid from '@mui/material/Grid';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';

export interface CommentFormData {
  comment: string;
  recipientIds?: number[];
}

export interface CommentFormProps {
  title?: React.ReactNode;
  onCancel?: () => void;
  onSubmit: (data: CommentFormData) => void;
  children?: React.ReactNode;
  loading?: boolean;
  error?: React.ReactNode;
}

type Props = CommentFormProps;

const CommentForm = ({ title, onSubmit, onCancel, children, loading, error }: Props) => {
  const [comment, setComment] = useState('');
  const [recipientIds, setRecipientIds] = useState([]);

  const handleSubmit = useCallback(() => {
    onSubmit({
      comment,
      recipientIds,
    });
  }, [comment, onSubmit, recipientIds]);

  return (
    <Grid container textAlign='center' p={2}>
      {!!error && (
        <Grid item xs={12}>
          <Alert severity='error' sx={{ width: '100%' }}>
            {error}
          </Alert>
        </Grid>
      )}
      {(!!title || !!children) && (
        <Grid item xs={12}>
          {title}
          {children}
        </Grid>
      )}
      <Grid item xs={12}>
        <DialogContent>
          <TextField
            inputRef={forceFocus}
            margin='dense'
            id='comment'
            label='Comment'
            placeholder='Enter your comment here...'
            type='text'
            fullWidth
            defaultValue=''
            multiline={true}
            minRows='2'
            onChange={(e) => {
              setComment(e.target.value);
            }}
            onKeyDown={(e) => {
              e.stopPropagation();
            }}
          />
        </DialogContent>
      </Grid>
      <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
        {!!onCancel && (
          <Button
            onClick={onCancel}
            disabled={loading}
            sx={{
              padding: '7px 18px',
              width: '89px',
              height: '36px',
              borderRadius: '10px',
              border: '0.75px solid #0E0C19',
            }}
          >
            Cancel
          </Button>
        )}
        <Button
          onClick={handleSubmit}
          disabled={loading}
          sx={{
            padding: '7px 18px',
            width: '89px',
            height: '36px',
            background: '#0E0C19',
            borderRadius: '10px',
            color: '#FFFFFF',
          }}
        >
          Comment
        </Button>
      </Grid>
    </Grid>
  );
};

export default CommentForm;
